__turbopack_context__.v({
  "bestChoiceColumn": "TariffsTableDesktop-module-scss-module__GMlCVq__bestChoiceColumn",
  "bestChoiceLabel": "TariffsTableDesktop-module-scss-module__GMlCVq__bestChoiceLabel",
  "body": "TariffsTableDesktop-module-scss-module__GMlCVq__body",
  "boldSettingValue": "TariffsTableDesktop-module-scss-module__GMlCVq__boldSettingValue",
  "buttonWrapper": "TariffsTableDesktop-module-scss-module__GMlCVq__buttonWrapper",
  "choiceButton": "TariffsTableDesktop-module-scss-module__GMlCVq__choiceButton",
  "currencyIcon": "TariffsTableDesktop-module-scss-module__GMlCVq__currencyIcon",
  "currentTariff": "TariffsTableDesktop-module-scss-module__GMlCVq__currentTariff",
  "goldFishIcon": "TariffsTableDesktop-module-scss-module__GMlCVq__goldFishIcon",
  "header": "TariffsTableDesktop-module-scss-module__GMlCVq__header",
  "headerCell": "TariffsTableDesktop-module-scss-module__GMlCVq__headerCell",
  "hint": "TariffsTableDesktop-module-scss-module__GMlCVq__hint",
  "infoColumns": "TariffsTableDesktop-module-scss-module__GMlCVq__infoColumns",
  "infoDescription": "TariffsTableDesktop-module-scss-module__GMlCVq__infoDescription",
  "infoDescriptionLink": "TariffsTableDesktop-module-scss-module__GMlCVq__infoDescriptionLink",
  "labelCell": "TariffsTableDesktop-module-scss-module__GMlCVq__labelCell",
  "labelSetting": "TariffsTableDesktop-module-scss-module__GMlCVq__labelSetting",
  "settingDescription": "TariffsTableDesktop-module-scss-module__GMlCVq__settingDescription",
  "settingValue": "TariffsTableDesktop-module-scss-module__GMlCVq__settingValue",
  "settingsColumn": "TariffsTableDesktop-module-scss-module__GMlCVq__settingsColumn",
  "showMoreButton": "TariffsTableDesktop-module-scss-module__GMlCVq__showMoreButton",
  "showMoreButtonWrapper": "TariffsTableDesktop-module-scss-module__GMlCVq__showMoreButtonWrapper",
  "table": "TariffsTableDesktop-module-scss-module__GMlCVq__table",
  "tariffCell": "TariffsTableDesktop-module-scss-module__GMlCVq__tariffCell",
  "tariffDate": "TariffsTableDesktop-module-scss-module__GMlCVq__tariffDate",
  "tariffDescription": "TariffsTableDesktop-module-scss-module__GMlCVq__tariffDescription",
  "tariffName": "TariffsTableDesktop-module-scss-module__GMlCVq__tariffName",
  "title": "TariffsTableDesktop-module-scss-module__GMlCVq__title",
  "withoutCommission": "TariffsTableDesktop-module-scss-module__GMlCVq__withoutCommission",
});
